<template>
	<div class="english" :class="{ 'dark-theme': isDarkMode }">
		<div class="container">
			<h1>Konsultacje i lekcje języka angielskiego</h1>
			<section class="intro">
				<p>
					Oferujemy indywidualne konsultacje oraz lekcje języka angielskiego dla 2-3 osób, dostosowane do
					Twojego poziomu i potrzeb.
					Niezależnie od tego, czy chcesz poprawić swoje umiejętności biznesowe, przygotować się do egzaminu,
					czy po prostu lepiej mówić po angielsku – pomożemy Ci osiągnąć Twoje cele.
				</p>
			</section>
			<section class="details">
				<h2>Dlaczego warto wybrać nasze lekcje?</h2>
				<ul>
					<li><strong>Indywidualne podejście:</strong> Lekcje szyte na miarę Twoich potrzeb i poziomu
						zaawansowania.</li>
					<li><strong>Małe grupy:</strong> Maksymalnie 3 osoby, co zapewnia komfort i intensywną naukę.</li>
					<li><strong>Elastyczność:</strong> Terminy i tematyka dopasowane do Twojego harmonogramu.</li>
					<li><strong>Praktyczne podejście:</strong> Skupiamy się na konwersacjach i realnych sytuacjach.</li>
				</ul>
			</section>
			<section class="cta">
				<button class="cta-btn" @click="goToContact">Zapisz się na lekcję próbną</button>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['theme'],
	computed: {
		isDarkMode() {
			return this.theme.isDarkMode;
		},
	},
	methods: {
		goToContact() {
			this.$router.push('/contact');
		},
	},
};
</script>

<style scoped>
.english {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transition: all 0.3s ease;
}

.english:not(.dark-theme) {
	background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
	color: #1f2937;
}

.english.dark-theme {
	background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
	color: #f9fafb;
}

.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px 20px;
}

h1 {
	font-size: 2.5rem;
	color: #00b4d8;
	text-align: center;
	margin-bottom: 30px;
}

.intro p {
	font-size: 1.2rem;
	line-height: 1.8;
	text-align: center;
	margin-bottom: 40px;
}

.details {
	margin-bottom: 40px;
}

.details h2 {
	font-size: 1.8rem;
	color: #ff0000;
	margin-bottom: 20px;
	text-align: center;
}

.details ul {
	list-style: none;
	padding: 0;
}

.details li {
	font-size: 1.1rem;
	line-height: 1.6;
	margin-bottom: 15px;
}

.details li strong {
	color: #00b4d8;
}

.cta {
	text-align: center;
}

.cta-btn {
	background: linear-gradient(90deg, #ff0000, #00b4d8);
	color: #fff;
	padding: 12px 24px;
	border: none;
	border-radius: 8px;
	font-size: 1.2rem;
	cursor: pointer;
	transition: transform 0.3s ease;
}

.cta-btn:hover {
	transform: scale(1.05);
}

@media (max-width: 768px) {
	h1 {
		font-size: 2rem;
	}

	.intro p {
		font-size: 1rem;
	}

	.details h2 {
		font-size: 1.5rem;
	}

	.details li {
		font-size: 1rem;
	}
}
</style>